import css from './ToastContent.module.css'
import {TextMidd} from "@/components/ui/Text";

interface ToastContentProps {
    message: string
    linkText?: string
    onLinkClick?: () => void
    type?: 'error'
}

const ToastContent = ({ message, linkText, onLinkClick, type }: ToastContentProps) => {
    const toastClassName = type === 'error' ? `${css.toast} ${css.error}` : css.toast

    return (
        <div className={toastClassName}>
            <TextMidd>
                {message}
            </TextMidd>
            {linkText && (
                <div className={css.link} onClick={onLinkClick}>
                    <TextMidd>{linkText}</TextMidd>
                </div>
            )}
        </div>
    )
}

export default ToastContent
